import React, { useEffect, useRef } from 'react';
import Type from 'prop-types';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router-dom';
import { ActivityIndicator, EmptyState } from 'components';
import { useTranslation } from 'hooks';
import { usePledges } from 'hooks/api/cascade';
import { useAbortRequest } from 'utils/useAbortRequest';
import { PledgeList } from './components';

const PledgesScreen = (props) => {
  const { listHeight } = props;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { entityId } = useParams();
  const { abortSignal } = useAbortRequest();
  const { status, isError, error, data } = usePledges(entityId, abortSignal);

  const listRef = useRef(null);

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }, [isError]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderPledges = () => {
    const { pledges } = data;
    const hasPledges = pledges.length !== 0;

    if (!hasPledges) {
      return <EmptyState title={t('noPledgesByCurrentCustomer')} />;
    }

    return (
      <PledgeList ref={listRef} listHeight={listHeight} pledges={pledges} />
    );
  };

  const renderFetchState = () => {
    switch (status) {
      case 'loading':
        return <ActivityIndicator />;
      case 'success':
        return renderPledges();
      default:
        return null;
    }
  };

  return <>{renderFetchState()}</>;
};

PledgesScreen.propTypes = {
  listHeight: Type.number.isRequired,
};

export default PledgesScreen;
